import { combineReducers } from "redux";
import auth from "./auth";
import languageRedux from "./languages";
import localizationReducer from "./localization";
import loader from "./loader";

const rootReducer = combineReducers({
  auth: auth.reducers,
  language: languageRedux.reducers,
  locale: localizationReducer,
  loader: loader.reducers,
});

export default rootReducer;
